import React from 'react';

import Error from './_error';

const Error404Page = () => <Error statusCode={404} />;

export default Error404Page;
